module.exports = __webpack_public_path__ + "static/media/default-user-image.a04d849c.jpg";